



















import Vue from "vue";
import PPCollectOrderDialog from "@/picking-portal/components/dialogs/PPCollectOrderDialog.vue";
import { orderService } from "@/picking-portal/services/PPOrderService";
import { Result } from "@zxing/library";
import Scanner from "@/common/components/scanner/Scanner.vue";
import { PPOrder } from "@/picking-portal/models/PPOrder";
import { PPClickAndCollectStatus } from "@/picking-portal/enums/PPClickAndCollectStatus";

export default Vue.extend({
  name: "PPCollectOrderScanner",
  components: {
    Scanner,
    PPCollectOrderDialog,
  },
  data() {
    return {
      PPClickAndCollectStatus,
      transactionId: "" as string,
      restrictedAge: 0 as number,
      dialogOpen: false as boolean,
      scanning: false as boolean,
      order: {} as PPOrder,
      orderFound: false as boolean,
      result: null as null | Result,
    };
  },
  methods: {
    onCloseDialog(): void {
      this.dialogOpen = false;
    },
    async onScanned(result: Result): Promise<void> {
      if (result.getText() !== this.result?.getText()) {
        await this.onCode(result.getText());
      }
      this.result = result;
    },
    async onCode(transactionId: string): Promise<void> {
      this.order = await orderService.getFulfillment(transactionId);
      if (this.order) {
        this.orderFound = true;
        this.scanning = false;
        this.restrictedAge = orderService.getRestrictedAgeForOrder(this.order);
        this.transactionId = this.order.transactionId;
        if (this.order.status === PPClickAndCollectStatus.PICKED) {
          await orderService.setFulfillmentCollected(transactionId);
        }
        this.dialogOpen = true;
      }
    },
  },
});
